import React from 'react';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Domingo a la noche buscando cómo bajar a Kant o Nietzsche a un lenguaje que tus alumnos no ignoren.', 'Clases improvisadas porque los libros de texto son densos, aburridos y desconectados de la realidad.', 'Alumnos "zombis" que solo esperan el timbre porque sienten que la filosofía no sirve para nada.', 'Evaluaciones fallidas porque todos se copian con ChatGPT y no hay reflexión real.', 'Horas perdidas preparando presentaciones que al final nadie mira.'];
  return <section className="py-5 md:py-6 px-4 bg-brand-dark" data-id="element-112">
      <div className="max-w-3xl mx-auto" data-id="element-113">
        <h2 className="text-lg md:text-2xl font-black text-center mb-4 text-white leading-tight uppercase" data-id="element-114">
          Si sos profesor de Filosofía o Ética, esto te va a sonar familiar:
        </h2>

        <div className="bg-brand-card border-l-4 border-red-500 p-4 md:p-5 rounded-r-lg mb-5 shadow-[0_0_15px_rgba(239,68,68,0.2)]" data-id="element-115">
          <div className="space-y-3" data-id="element-116">
            {points.map((point, index) => <div key={index} className="flex items-start" data-id="element-117">
                <XCircle className="w-5 h-5 text-red-500 mr-3 shrink-0 mt-0.5" data-id="element-118" />
                <p className="text-sm md:text-base text-gray-200 font-bold leading-relaxed" data-id="element-119">
                  {point}
                </p>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-120">
          <h3 className="text-base md:text-xl font-black text-brand-accent neon-glow leading-tight uppercase" data-id="element-121">
            ¿Cuántos fines de semana más vas a perder intentando "descifrar"
            textos para adolescentes que no quieren leer?
          </h3>
        </div>
      </div>
    </section>;
}